import { EntryForm } from "../components/EntryForm.tsx";
import { EntryList } from "../components/EntryList.tsx";
import { Loader } from "../components/Loader.tsx";
import { api } from "../lib/api.ts";
import { useIsOwner } from "../lib/auth.ts";
import { useAsync } from "../lib/useAsync.ts";
import type { Entry, Mood } from "../lib/types.ts";

export function Today() {
  const isOwner = useIsOwner();

  const { data, error, loading, reload } = useAsync<{
    moods: Mood[];
    entries: Entry[];
  }>(async () => {
    const [moods, entries] = await Promise.all([api.moods(), api.today()]);
    return { moods, entries };
  }, []);

  return (
    <Loader loading={loading} error={error}>
      {data && (
        <>
          {isOwner && (
            <section className="card">
              <div className="card__head">
                <h2>{data.entries.length > 0 ? "Añadir otro registro" : "¿Cómo estás hoy?"}</h2>
                {data.entries.length > 0 && (
                  <span className="card__hint">
                    {data.entries.length}{" "}
                    {data.entries.length === 1 ? "registro hoy" : "registros hoy"}
                  </span>
                )}
              </div>

              <EntryForm
                moods={data.moods}
                onSubmit={async (input) => {
                  await api.createEntry(input);
                  reload();
                }}
              />
            </section>
          )}

          {(data.entries.length > 0 || !isOwner) && (
            <section className="card">
              <div className="card__head">
                <h2>Registros de hoy</h2>
              </div>
              {data.entries.length === 0 ? (
                <p className="empty">Todavía no hay ningún registro hoy.</p>
              ) : (
                <EntryList
                  entries={data.entries}
                  moods={data.moods}
                  onUpdate={
                    isOwner
                      ? async (id, input) => {
                          await api.updateEntry(id, input);
                          reload();
                        }
                      : undefined
                  }
                  onDelete={
                    isOwner
                      ? async (id) => {
                          await api.deleteEntry(id);
                          reload();
                        }
                      : undefined
                  }
                />
              )}
            </section>
          )}
        </>
      )}
    </Loader>
  );
}
